import scrollMonitor from "scrollMonitor";
import Cookies from "js-cookie"
import deBounce from 'lodash.debounce'

import 'jquery';
import './foundation-setup';
import './transcend';

import '../Components/Widgets/News/news';
import '../Components/Widgets/Testimonials/testimonials';
import '../Components/Widgets/ReviewList/review-list';
import '../Components/Widgets/VerticalForm/vertical-form';
import '../Components/Widgets/WrongsWeRightSlider/wrongsWeRightSlider';
import '../Components/Widgets/PhotoCarousel/photoCarousel';
import '../Components/Widgets/UniqueSellingPropositions/uniqueSellingPropositions';
import '../Components/Widgets/NewsLogosLinked/news-logos';
import '../Components/Widgets/VideoTestimonials/video-testimonials';
import '../Components/Widgets/RecommendedArticles/recommended-articles';
import '../Components/Widgets/MapWithPin/map-with-pin';

jQuery(document).ready(function ($) {
    // mobile menu and sticky header desktop memu
    $(document).on("click", ".hamburger", function () {
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
            $('#hamburger-menu').addClass('is-active');
        } else {
            $('#hamburger-menu').removeClass('is-active');
        }

        if ($(this).parents("header").length) {
            $("#hamburger-menu").addClass("mobile-menu");
        } else {
            $("#hamburger-menu").removeClass("mobile-menu");
        }
    });
    $(window).resize(deBounce(function () {
        // cleanup and reset menus on resize
        $('#hamburger-menu, .hamburger').removeClass('is-active');
    }, 100));

    $(document).on("click", ".market-hamburger", function () {
        $(this).toggleClass("is-active");
        $("#market-sub-nav-hamburger-menu").toggleClass("is-active");
    });

    $('#hamburger-menu li').on('click', '.submenu-header, .submenu-arrow', function (e) {
        if ($(this).closest('.mobile-menu.is-active').length) {
            e.preventDefault();
            $(this).closest('li').toggleClass('open');
        }
    });

    // add repeat of submenu header link to submenu for mobile menu
    $('.submenu-header').each(function () {
        $('<li>', { class: 'mobile-only' })
            .append($(this).clone().removeAttr('class'))
            .prependTo($(this).next('ul.submenu-list'));
    });

    // sticky header if lead form is not on page
    if (!$('#lead-form').length) {
        let targetElementSelector = $(".hero #lead-address").length ? ".hero #lead-address" : "header.module";
        let targetElement = scrollMonitor.create(document.querySelector(targetElementSelector));

        targetElement.enterViewport(() => {
            $("#header-form").removeClass("is-active");
            $("#hamburger-menu, .hamburger").removeClass("is-active");
        });

        targetElement.exitViewport(() => {
            $("#header-form").addClass("is-active");
        });
    }

    // ensure google maps api is loaded when user clicks in address box
    $('#lead-address, #lead-address2').on('focus', loadAddrAutosuggest);
    function loadAddrAutosuggest() {
        // only do this once: remove event listener
        $('#lead-address, #lead-address2').off('focus', loadAddrAutosuggest);

        if ($('script[src*="maps.googleapis.com"]').length == 0) {
            $('<script src="https://maps.googleapis.com/maps/api/js?key=' + window.wbuh.mapKey + '&libraries=places&callback=initAddrAutosuggest&loading=async" async></script>').appendTo('head');
        }
        else {
            // maps API is already loaded (likely on locations page)
            initAddrAutosuggest();
        }
    }


    // save any UTM data for later submission
    if (getQueryVariable('utm_medium'))
        Cookies.set('utm_medium', getQueryVariable('utm_medium'));
    if (getQueryVariable('utm_source'))
        Cookies.set('utm_source', getQueryVariable('utm_source'));
    if (getQueryVariable('utm_campaign'))
        Cookies.set('utm_campaign', getQueryVariable('utm_campaign'));
    if (getQueryVariable('utm_content'))
        Cookies.set('utm_content', getQueryVariable('utm_content'));
    if (getQueryVariable('ttdclid'))
        Cookies.set('ttdclid', getQueryVariable('ttdclid'));
    if (getQueryVariable('msclid'))
        Cookies.set('msclid', getQueryVariable('msclid'));
    if (getQueryVariable('gclid'))
        Cookies.set('gclid', getQueryVariable('gclid'));
    if (getQueryVariable('msclkid'))
        Cookies.set('msclkid', getQueryVariable('msclkid'));
    if (getQueryVariable('fbclid'))
        Cookies.set('fbclid', getQueryVariable('fbclid'));
    if (getQueryVariable('utm_term'))
        Cookies.set('utm_term', getQueryVariable('utm_term'));


    // blog Load More button
    if ($('#load-more-blogs').length) {
        let nextPage;
        if (getQueryVariable('page'))
            nextPage = parseInt(getQueryVariable('page')) + 1;
        else
            nextPage = 2;

        $('#load-more-blogs').on('click', function () {
            let $btn = $(this);

            $.get(
                window.location.pathname + "?ajax=true&page=" + nextPage,
                function (blogInfo) {
                    $.each(blogInfo.blogs, function () {
                        let options = {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        };
                        const categoriesURL = this.categories[0].url;
                        let postHtml = `
                        <div class="post">
                            <h2><a href="${this.url}">${this.title}</a></h2>
                            <div class="post-info">
                                Posted in <a href=${categoriesURL}>${this.categories[0].text
                                                    }</a> on ${new Date(this.date).toLocaleDateString(
                                                        undefined,
                                                        options
                                                    )}        
                            </div>
                            <p>${this.excerpt}</p>
                            <a class="gb-button read-more-button" href="${this.url}" aria-label="Read post: ${this.title
                                                    }">Read More</a>
                        </div>`;
                        $(postHtml).insertBefore($btn);
                    });

                    // prepare next page or hide button
                    if (blogInfo.hasMorePages) nextPage++;
                    else $btn.hide();
                }
            );
        });
    }

}); // end document.ready


function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable)
            return pair[1];
    }
    return (false);
}

window.initAddrAutosuggest = function () {
    enterYourAddressAutosuggest();
    if ($('form.autosuggest').length)
        setupLeadFormAutoSuggest();

};

function enterYourAddressAutosuggest() {
    //Set up the address autosuggest    
    var options = {
        componentRestrictions: { country: "US" }
    };

    $('#lead-address, #lead-address2').each(function () {
        var input = this;

        var autocomplete = new google.maps.places.Autocomplete(input, options);

        // store address when selected from dropdown
        autocomplete.addListener('place_changed', function () {

            var place = autocomplete.getPlace();

            $(input).siblings('.lead-form-button').html('Loading');

            var stnum, stname, city, state, zipcode;

            for (var i = 0; i < place.address_components.length; i++) {

                for (var j = 0; j < place.address_components[i].types.length; j++) {

                    if (place.address_components[i].types[j] == "street_number") stnum = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "route") stname = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "locality") city = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "administrative_area_level_1") state = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "postal_code") zipcode = place.address_components[i]['short_name'];

                }

            }

            var street = "";
            if (typeof (stnum) !== 'undefined') street += stnum + " ";
            if (typeof (stname) !== 'undefined') street += stname;

            localStorage.setItem("street_address", street);
            localStorage.setItem("city", city);
            localStorage.setItem("state", state);
            localStorage.setItem("zip", zipcode);

            var destUrl = $(input).closest('form').attr('action');
            window.location.href = destUrl;

        });

        // store address when submitted without using dropdown
        $(this).closest('form').on('submit', function () {
            let address;
            if ($('#lead-address').val() != '')
                address = ParseAddressEsri($('#lead-address').val());
            else
                address = ParseAddressEsri($('#lead-address2').val());

            if (address.state.length > 2)
                address.state = getCodeFromStateName(address.state);

            localStorage.setItem("street_address", address.street);
            localStorage.setItem("city", address.city);
            localStorage.setItem("state", address.state);
            localStorage.setItem("zip", address.postalCode);
        });
    });
}

$(window).on('pageshow', function () {
    $('input#lead-address2').siblings('.lead-form-button').html('GET A CASH OFFER');
});


// function from https://stackoverflow.com/questions/11160192/how-to-parse-freeform-street-postal-address-out-of-text-and-into-components#answer-49307309
// is not perfect, but we allow user to correct
function ParseAddressEsri(singleLineaddressString) {
    var address = {
        street: "",
        city: "",
        state: "",
        postalCode: ""
    };

    // tokenize by space (retain commas in tokens)
    var tokens = singleLineaddressString.split(/[\s]+/);
    var tokenCount = tokens.length;
    var lastToken = tokens.pop();
    if (
        // if numeric assume postal code (ignore length, for now)
        !isNaN(lastToken) ||
        // if hyphenated assume long zip code, ignore whether numeric, for now
        lastToken.split("-").length - 1 === 1) {
        address.postalCode = lastToken;
        lastToken = tokens.pop();
    }

    if (lastToken && isNaN(lastToken)) {

        var potentialState = lastToken.replace(',', '').toLowerCase();
        for (var i = 0; i < usStates.length; i++) {
            if (usStates[i].abbreviation.toLowerCase() == potentialState) {
                address.state = usStates[i].abbreviation;
                lastToken = tokens.pop();
                break;
            }
        }

        if (address.state.length === 0) {
            // check for special case: might have State name instead of State Code.
            var stateNameParts = [lastToken.endsWith(",") ? lastToken.substring(0, lastToken.length - 1) : lastToken];

            // check remaining tokens from right-to-left for the first comma
            while (2 + 2 != 5) {
                lastToken = tokens.pop();
                if (!lastToken) break;
                else if (lastToken.endsWith(",")) {
                    // found separator, ignore stuff on left side
                    tokens.push(lastToken); // put it back
                    break;
                } else {
                    stateNameParts.unshift(lastToken);
                }
            }

            for (var i = 0; i < usStates.length; i++) {
                if (usStates[i].name.toLowerCase() == stateNameParts.join(' ').toLowerCase()) {
                    address.state = usStates[i].abbreviation;
                    lastToken = tokens.pop();
                    break;
                }
            }
        }
    }

    if (lastToken) {
        // here is where it gets trickier:
        if (address.state.length) {
            // if there is a state, then assume there is also a city and street.
            // PROBLEM: city may be multiple words (spaces)
            // but we can pretty safely assume next-from-last token is at least PART of the city name
            // most cities are single-name. It would be very helpful if we knew more context, like
            // the name of the city user is in. But ignore that for now.
            // ideally would have zip code service or lookup to give city name for the zip code.
            var cityNameParts = [lastToken.endsWith(",") ? lastToken.substring(0, lastToken.length - 1) : lastToken];

            // assumption / RULE: street and city must have comma delimiter
            // addresses that do not follow this rule will be wrong only if city has space
            // but don't care because Esri formats put comma before City
            var streetNameParts = [];

            // check remaining tokens from right-to-left for the first comma
            while (2 + 2 != 5) {
                lastToken = tokens.pop();
                if (!lastToken) break;
                else if (lastToken.endsWith(",")) {
                    // found end of street address (may include building, etc. - don't care right now)
                    // add token back to end, but remove trailing comma (it did its job)
                    tokens.push(lastToken.endsWith(",") ? lastToken.substring(0, lastToken.length - 1) : lastToken);
                    streetNameParts = tokens;
                    break;
                } else {
                    cityNameParts.unshift(lastToken);
                }
            }
            address.city = cityNameParts.join(' ');
            address.street = streetNameParts.join(' ');
        } else {
            // if there is NO state, then assume there is NO city also, just street! (easy)
            // reasoning: city names are not very original (Portland, OR and Portland, ME) so if user wants city they need to store state also (but if you are only ever in Portlan, OR, you don't care about city/state)
            // put last token back in list, then rejoin on space
            tokens.push(lastToken);
            address.street = tokens.join(' ');
        }
    }
    // when parsing right-to-left hard to know if street only vs street + city/state
    // hack fix for now is to shift stuff around.
    // assumption/requirement: will always have at least street part; you will never just get "city, state"  
    // could possibly tweak this with options or more intelligent parsing&sniffing
    if (!address.city && address.state) {
        address.city = address.state;
        address.state = '';
    }
    if (!address.street) {
        address.street = address.city;
        address.city = '';
    }

    return address;
}

function getCodeFromStateName(stateName) {

    usStates.forEach(function (st) {
        if (st.name.toLowerCase() == stateName.toLowerCase())
            return st.abbreviation;
    });
    return '';
}

var usStates = [
    { name: 'ALABAMA', abbreviation: 'AL' },
    { name: 'ALASKA', abbreviation: 'AK' },
    { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
    { name: 'ARIZONA', abbreviation: 'AZ' },
    { name: 'ARKANSAS', abbreviation: 'AR' },
    { name: 'CALIFORNIA', abbreviation: 'CA' },
    { name: 'COLORADO', abbreviation: 'CO' },
    { name: 'CONNECTICUT', abbreviation: 'CT' },
    { name: 'DELAWARE', abbreviation: 'DE' },
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
    { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
    { name: 'FLORIDA', abbreviation: 'FL' },
    { name: 'GEORGIA', abbreviation: 'GA' },
    { name: 'GUAM', abbreviation: 'GU' },
    { name: 'HAWAII', abbreviation: 'HI' },
    { name: 'IDAHO', abbreviation: 'ID' },
    { name: 'ILLINOIS', abbreviation: 'IL' },
    { name: 'INDIANA', abbreviation: 'IN' },
    { name: 'IOWA', abbreviation: 'IA' },
    { name: 'KANSAS', abbreviation: 'KS' },
    { name: 'KENTUCKY', abbreviation: 'KY' },
    { name: 'LOUISIANA', abbreviation: 'LA' },
    { name: 'MAINE', abbreviation: 'ME' },
    { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
    { name: 'MARYLAND', abbreviation: 'MD' },
    { name: 'MASSACHUSETTS', abbreviation: 'MA' },
    { name: 'MICHIGAN', abbreviation: 'MI' },
    { name: 'MINNESOTA', abbreviation: 'MN' },
    { name: 'MISSISSIPPI', abbreviation: 'MS' },
    { name: 'MISSOURI', abbreviation: 'MO' },
    { name: 'MONTANA', abbreviation: 'MT' },
    { name: 'NEBRASKA', abbreviation: 'NE' },
    { name: 'NEVADA', abbreviation: 'NV' },
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
    { name: 'NEW JERSEY', abbreviation: 'NJ' },
    { name: 'NEW MEXICO', abbreviation: 'NM' },
    { name: 'NEW YORK', abbreviation: 'NY' },
    { name: 'NORTH CAROLINA', abbreviation: 'NC' },
    { name: 'NORTH DAKOTA', abbreviation: 'ND' },
    { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
    { name: 'OHIO', abbreviation: 'OH' },
    { name: 'OKLAHOMA', abbreviation: 'OK' },
    { name: 'OREGON', abbreviation: 'OR' },
    { name: 'PALAU', abbreviation: 'PW' },
    { name: 'PENNSYLVANIA', abbreviation: 'PA' },
    { name: 'PUERTO RICO', abbreviation: 'PR' },
    { name: 'RHODE ISLAND', abbreviation: 'RI' },
    { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
    { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
    { name: 'TENNESSEE', abbreviation: 'TN' },
    { name: 'TEXAS', abbreviation: 'TX' },
    { name: 'UTAH', abbreviation: 'UT' },
    { name: 'VERMONT', abbreviation: 'VT' },
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
    { name: 'VIRGINIA', abbreviation: 'VA' },
    { name: 'WASHINGTON', abbreviation: 'WA' },
    { name: 'WEST VIRGINIA', abbreviation: 'WV' },
    { name: 'WISCONSIN', abbreviation: 'WI' },
    { name: 'WYOMING', abbreviation: 'WY' }
];